/* eslint-disable promise/avoid-new */

// need to update dbVersion each time we need to add/update/delete new object store
const dbVersion = 7

let db

export const Stores = {
  backgroundImageStore: 'background_images',
  questionImageStore: 'question_images',
  slideOptionImageStore: 'slide_option_images',
  hintImageStore: 'hint_images',
  contentSlideCategoriesStore: 'content_slide_categories',
  contentSlideCanvasBlocksStore: 'content_slide_blocks',
}

export function initIndexedDB(onErrorCb, onSuccessCb) {
  if (!window || !window.indexedDB) return
  const request = window.indexedDB.open('ahaslides', dbVersion)
  request.onsuccess = (event) => {
    db = event.target.result

    if (onSuccessCb) {
      onSuccessCb(event)
    }
  }
  request.onerror = () => {
    if (onErrorCb) {
      onErrorCb(request.error)
    }
  }
  request.onupgradeneeded = (e) => {
    const Db = e.target.result
    if (!Db.objectStoreNames.contains(Stores.backgroundImageStore)) {
      Db.createObjectStore(Stores.backgroundImageStore, {
        keyPath: 'id',
        autoIncrement: false,
      })
    }
    if (!Db.objectStoreNames.contains(Stores.questionImageStore)) {
      Db.createObjectStore(Stores.questionImageStore, {
        keyPath: 'id',
        autoIncrement: false,
      })
    }
    if (!Db.objectStoreNames.contains(Stores.slideOptionImageStore)) {
      Db.createObjectStore(Stores.slideOptionImageStore, {
        keyPath: 'id',
        autoIncrement: false,
      })
    }
    if (!Db.objectStoreNames.contains(Stores.hintImageStore)) {
      Db.createObjectStore(Stores.hintImageStore, {
        keyPath: 'id',
        autoIncrement: false,
      })
    }
    if (!Db.objectStoreNames.contains(Stores.contentSlideCategoriesStore)) {
      Db.createObjectStore(Stores.contentSlideCategoriesStore, {
        keyPath: 'id',
        autoIncrement: false,
      })
    }
    if (!Db.objectStoreNames.contains(Stores.contentSlideCanvasBlocksStore)) {
      Db.createObjectStore(Stores.contentSlideCanvasBlocksStore, {
        keyPath: 'id',
        autoIncrement: false,
      })
    }
  }
}

export function setObjectToIndexedDB(key, store, object, onErrorCb, onCompleteCb) {
  if (!db) return
  const defaultTtl = 7 * 24 * 3600e3 // 7 days

  const transaction = db.transaction([store], 'readwrite')

  const saveReq = transaction.objectStore(store).put({
    id: key,
    ...object,
    expire: new Date().getTime() + (object.ttl || defaultTtl),
  })
  saveReq.onerror = (e) => {
    if (onErrorCb) onErrorCb(e)
  }
  saveReq.onsuccess = (e) => {
    if (onCompleteCb) {
      onCompleteCb(e)
    }
  }
}

export function removeObjectFromIndexedDB(key, store, onErrorCb, onCompleteCb) {
  if (!db || !key) return
  const transaction = db.transaction([store], 'readwrite')
  const deleteReq = transaction.objectStore(store).delete(key)
  deleteReq.onerror = (e) => {
    if (onErrorCb) onErrorCb(e)
  }
  deleteReq.onsuccess = (e) => {
    if (onCompleteCb) onCompleteCb(e)
  }
}

export function getAllImageFromIndexedDB(store) {
  if (!db) return null
  const transaction = db.transaction([store], 'readonly')
  const readReq = transaction.objectStore(store).getAll()
  return new Promise((resolve, reject) => {
    readReq.onsuccess = (e) => {
      const data = e.target.result
      resolve(data)
    }
    readReq.onerror = (e) => {
      reject(e)
    }
  })
}

export function getObjectFromIndexedDB(slideId, store) {
  if (!db) return null
  const transaction = db.transaction([store], 'readonly')
  const readReq = transaction.objectStore(store).get(slideId)
  return new Promise((resolve, reject) => {
    readReq.onsuccess = (e) => {
      const data = e.target.result
      if (!data) {
        return resolve(null)
      }
      if (new Date().getTime() > data.expire) {
        removeObjectFromIndexedDB(slideId, store)
        return resolve(null)
      }
      resolve(data)
    }
    readReq.onerror = (e) => {
      reject(e)
    }
  })
}
